// src/i18n/settings.ts —— settings 域文案包（06 C-14）。06 给出文案的键逐字取 06；「SP8 前端决定」与 06 缺双语文案的键本计划定稿（W-7 回写）
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_SETTINGS: I18nPack = {
  zh: {
cfgFeeTrcActivation:"TRC20未激活地址激活服务费（USDT）",
 gSharedPayments:'固定地址收款',cfgSharedTrc:'TRC20共享地址收款',cfgSharedErc:'ERC20共享地址收款',cfgSharedBep:'BEP20共享地址收款',cfgSharedTtl:'订单付款时间（300–600秒）',cfgSharedPending:'每用户待付款上限',cfgSharedDaily:'每用户每日新单上限',
    cfgHint: '保存后立即对用户端与分销端生效，并写入操作记录。', // 06 C-14 [改写 key]
    gPlatform: '平台与客服',
    gOps: '告警与合规',
    cfgPrevSettle: '结算时间',
    cfgPrevSettleVal: '每日 {time}（{tz}）', // 06 C-14 预览区「每日 {settleTime}（{timezone}）」
    cfgPrevWithdrawFee: '提币手续费（TRC20）',
    cfgPrevCardFees: '卡片费率',
    cfgPrevCardFeesVal: '以「卡产品与风控」各产品配置为准',
    // 用户 2026-10-18：卡类费用键只作新同步卡产品的默认值（已有产品在「卡产品与风控」单独改），标签显式标注
    cfgOpenFee: '新产品默认开卡费 (USD/张)',
    maintTextEmpty: '维护文案为空',
    cfgWdReview: '提币二级审批阈值 (USDT)',
    // 0038（用户需求 2026-10-15）：Console 自动付款额度；说明挂在「限额设置」分组提示
    cfgPayoutAuto: '自动付款额度 (USDT)',
    cfgPayoutAutoHint: '自动付款额度（USDT）：审核通过后低于此额自动出款，达到或超过此额需财务在财务工作台发起；实际生效值不超过财务机硬上限。填 0 = 全部由财务人工发起。',
    // 0050（2026-10-21 风控）：单用户每日开卡上限
    cfgMaxOpenPerDay: '每用户每日最多开卡数',
    cfgMaxOpenPerDayHint: '每用户每日最多开卡数：按本页时区的自然日计，统计当日已提交且未失败的开卡（含处理中），达到后 H5 与 Bot 当日不能再开卡。填 0 = 不限。',
    cfgTolerance: '充值订单匹配容差 (USDT)',
    cfgMaxAgentRate: '用户链充值奖励上限 (%)', // 0045：代理返佣废弃，本键仅约束用户链 l1Top+l2Top
    cfgWdFeeUsdt: '提佣手续费 · USDT (USD/笔)',
    cfgWdFeeWallet: '提佣手续费 · 平台钱包 (USD/笔)',
    cfgUpTopupFeeFixed: '上游预算充值固定手续费 (USD/笔)',
    cfgUpTopupFeeRate: '上游预算充值手续费率 (%)',
    cfgUpWithdrawFeeFixed: '上游预算转出固定手续费 (USD/笔)',
    cfgUpWithdrawFeeRate: '上游预算转出手续费率 (%)',
    cfgSiteUrl: '官网地址',
    cfgAppUrl: '用户中心地址',
    // D-42（用户报障根因修复 2026-10-10）：siteUrl / appUrl 为空的显著告警文案
    cfgEmptyWarn: '未配置：为空将导致官网登录 / 注册按钮与 Telegram Mini App 入口不可用，请在上线前填写。',
    cfgTxFeeRate: '新产品默认交易手续费率 (%)',
    cfgTxFeeFixed: '新产品默认交易固定费 (USD/笔)',
    cfgCrossRate: '新产品默认跨境费率 (%)',
    cfgCrossFixed: '新产品默认跨境固定费 (USD/笔)',
    cfgDeclinedFee: '新产品默认拒付费 (USD/笔)',
    cfgDisputeFee: '新产品默认争议费 (USD/笔)',
    // 以下本计划定稿
    cfgDepositFeeRate: '入金费率 (%)',
    cfgFXBaseRate: '平台兑换汇率（1 USDT 入账多少 USDT 余额，默认 1，如 0.9999）',
    cfgFXSpreadLimit: '代理汇率最大折让 (%)',
    cfgFXOutOfBand: '当前有 {total} 个代理报价超出新范围，已自动回退平台汇率，请联系代理调整。',
    cfgUpCostRate: '平台补款成本率 (%)',
    cfgWithdrawFeeRate: '提币费率 (%)',
    cfgCardWithdrawFee: '卡转出费 (USDT/笔)',
    cfgWarnLoss: '入金费率扣除用户邀请充值奖励上限后为 {effective_rate}%，低于平台补款成本 {upstream_cost_rate}%，存在亏损',
    cfgWarnMaxLevel: '当前最深层级为 {deepest}，已有代理不受影响，仅阻止新建超限下级', // D2（用户 2026-10-18）
    cfgCloseFee: '新产品默认销卡费 (USD/张)',
    cfgKycLimitVerified: '认证后累计充值上限 (USD)',
    cfgDepositReview: '充币复核阈值 (USDT)',
    cfgReserveAlert: '备付低水位告警阈值 (USD)',
    cfgTimezone: '平台时区 (IANA)',
    cfgSupportTg: '客服 Telegram',
    cfgSupportEmail: '客服邮箱',
    cfgSupportHours: '客服时间',
    cfgAlertChatId: '告警 Telegram 群 ID',
    cfgAlertEmail: '告警邮箱',
    // 2026-10-20 C-14 ⑦「发送测试告警」：按已保存配置各发一条测试消息，结果区分通道展示
    cfgAlertTest: '发送测试告警',
    cfgAlertTestHint: '按已保存的群 ID 与邮箱各发一条测试消息，不计入告警列表；每 30 秒最多 1 次。',
    cfgAlertTestSaveFirst: '有未保存的修改，请先保存配置再发送测试告警',
    cfgAlertTestTg: 'Telegram 群',
    cfgAlertTestEmail: '告警邮箱',
    cfgAlertTestOk: '已发送',
    cfgAlertTestFail: '失败（{err}）',
    cfgAlertTestUnknown: '未知原因',
    cfgAlertTestOkShort: '成功',
    cfgAlertTestFailShort: '失败',
    cfgAlertTestDone: '测试告警已执行：Telegram {tg}，邮箱 {email}',
    cfgPaySla: '提币支付 SLA (小时)',
    errCfgField: '{field} 取值不合法',
    unitLevel: '级',
    // 运营 UX 评审 2026-10-15 P0 #1–#4：保存反馈、未保存标记、离开拦截、回读核对
    cfgFeeHint: '平台补款成本率 (%)：保存入金费率时用于亏损提示，同时用于利润台账按充值计提上游补款成本（每笔充值 × 本费率，按充值时点的费率回溯）。',
    cfgSharedHint: '开关只决定是否向用户提供该网络充值。要真正可下单，还需要该网络至少一个收款地址「已生效」且「分配中」、监听正常；否则用户会看到「通道维护中」。',
    cfgUsNothing: '没有需要保存的修改',
    cfgUsSaved: '已保存 {n} 项并已回读核对：{labels}',
    cfgUsMismatch: '保存后读回不一致：{labels}，请刷新页面核对',
    cfgUsReadbackFail: '已提交，但读回核对失败（{err}），请刷新页面核对是否生效',
    cfgUsMore: ' 等 {n} 项',
    cfgUsSwitchUnsaved: '{state}（未保存）',
    cfgUsDirtyBar: '有 {n} 项修改未保存：{labels}。开关切换和数值修改都须点「保存全部配置」后才生效。',
    cfgUsLeaveTitle: '放弃未保存的修改？',
    cfgUsLeaveText: '有 {n} 项修改尚未保存（{labels}），离开将丢弃这些修改。确定离开？',
    cfgUsLeaveStay: '留在本页',
    cfgUsLeaveGo: '放弃修改并离开',
    // 2026-10-15 会话安全（06 C-14 ⑨）与卡片（⑩）
    gSecurity: '安全',
    cfgSecurityHint: '新值对新签发的会话 / 下次校验生效；Mini App 会话固定 12 小时不受影响。',
    cfgAdminIdle: '后台空闲自动退出（分钟）',
    cfgAdminMaxHours: '后台最长在线（小时）',
    cfgAgentIdle: '代理端空闲自动退出（分钟）',
    cfgAgentMaxHours: '代理端最长在线（小时）',
    cfgUserRefreshDays: '用户端登录保持（天）',
    gCard: '卡片',
    cfgCardSpentCooling: '卡已消费冷静期（分钟，交易后多久再与上游核对已消费；越短越及时，过短可能少算消费）',
    // 0052（2026-10-22 预算开卡名额耗尽致卡产品全部下架）
    cfgBudgetCardLow: '预算剩余开卡名额告警阈值',
    cfgBudgetCardLowHint: '预算剩余开卡名额告警阈值：本系统预算的上游剩余可开卡数小于或等于此值时发送「名额不足」告警；剩余为 0 时卡产品会自动下架、用户无法开卡，始终发送严重告警。填 0 = 只关闭名额不足告警。收到告警请在上游后台调大开卡上限，再到「预算池」点「同步预算」。',
    // 0041 运维健康巡检
    gHealth: '运维健康',
    cfgOpsHint: '后台任务每轮巡检主机磁盘 / 内存 / 负载、站点可用性与证书、数据库、财务机心跳与备份，越阈值按「告警与合规」的群 ID / 邮箱投递；问题恢复不会自动关闭告警，请在告警列表确认。',
    cfgOpsEnabled: '运维巡检',
    cfgOpsInterval: '巡检间隔（秒，30–3600）',
    cfgOpsDiskWarn: '磁盘使用率告警（≥ %）',
    cfgOpsDiskCrit: '磁盘使用率严重（≥ %）',
    cfgOpsMemWarn: '可用内存告警（< %）',
    cfgOpsMemCrit: '可用内存严重（< %）',
    cfgOpsLoadWarn: '每核 5 分钟负载告警（≥）',
    cfgOpsLoadCrit: '每核 5 分钟负载严重（≥）',
    cfgOpsSiteUrls: '巡检站点（https，逗号分隔，≤ 10 个）',
    cfgOpsSiteFail: '站点连续失败轮数（严重）',
    cfgOpsSiteP95: '站点 P95 延迟告警（最近 20 次）',
    cfgOpsTlsWarn: '证书剩余天数告警（≤ 天）',
    cfgOpsTlsCrit: '证书剩余天数严重（≤ 天）',
    cfgOpsDbPing: '数据库往返耗时告警（≥）',
    cfgOpsDbConn: '数据库连接占用告警（≥ %）',
    cfgOpsTreasuryStale: '财务机心跳超时（分钟，严重）',
    cfgOpsBackupAge: '备份超时未更新（小时）',
  },
  en: {
cfgFeeTrcActivation:"TRC20 activation fee for inactive address (USDT)",
 gSharedPayments:'Fixed-address deposits',cfgSharedTrc:'TRC20 shared deposits',cfgSharedErc:'ERC20 shared deposits',cfgSharedBep:'BEP20 shared deposits',cfgSharedTtl:'Payment period (300–600seconds)',cfgSharedPending:'Pending orders per user',cfgSharedDaily:'Daily new orders per user',
    cfgHint: 'Applies to the user app and agent portal immediately and is written to the operation log.', // 本计划定稿
    gPlatform: 'Platform & support',
    gOps: 'Alerts & compliance',
    cfgPrevSettle: 'Settlement time', // 本计划定稿
    cfgPrevSettleVal: 'Daily {time} ({tz})', // 本计划定稿
    cfgPrevWithdrawFee: 'Withdrawal fee (TRC20)',
    cfgPrevCardFees: 'Card fees',
    cfgPrevCardFeesVal: 'Per product, see Card products & risk',
    cfgOpenFee: 'New-product default issue fee (USD/card)',
    maintTextEmpty: 'Maintenance text is empty',
    cfgWdReview: 'Withdrawal dual-approval threshold (USDT)',
    cfgPayoutAuto: 'Auto-payout limit (USDT)',
    cfgPayoutAutoHint: 'Auto-payout limit (USDT): approved withdrawals below this amount are paid automatically; at or above it, finance starts the payout in the Finance Console. The effective value never exceeds the Finance host hard cap. 0 = all payouts manual.',
    cfgMaxOpenPerDay: 'Max new cards per user per day',
    cfgMaxOpenPerDayHint: 'Max new cards per user per day: counted per calendar day in this page\'s time zone, including submitted and in-progress card openings that have not failed. Once reached, the user cannot open more cards in the app or Bot until the next day. 0 = unlimited.',
    // 以下本计划定稿
    cfgTolerance: 'Top-up order match tolerance (USDT)',
    cfgMaxAgentRate: 'User referral top-up reward cap (%)',
    cfgWdFeeUsdt: 'Commission payout fee · USDT (USD/tx)',
    cfgWdFeeWallet: 'Commission payout fee · wallet (USD/tx)',
    cfgUpTopupFeeFixed: 'Upstream budget top-up fixed fee (USD/tx)',
    cfgUpTopupFeeRate: 'Upstream budget top-up fee rate (%)',
    cfgUpWithdrawFeeFixed: 'Upstream budget withdrawal fixed fee (USD/tx)',
    cfgUpWithdrawFeeRate: 'Upstream budget withdrawal fee rate (%)',
    cfgSiteUrl: 'Website URL',
    cfgAppUrl: 'User app URL',
    // D-42：同上
    cfgEmptyWarn: 'Not configured: while empty, the website log-in / sign-up buttons and the Telegram Mini App entry stay unavailable. Fill this in before going live.',
    cfgTxFeeRate: 'New-product default transaction fee rate (%)',
    cfgTxFeeFixed: 'New-product default transaction fixed fee (USD/tx)',
    cfgCrossRate: 'New-product default cross-border rate (%)',
    cfgCrossFixed: 'New-product default cross-border fixed fee (USD/tx)',
    cfgDeclinedFee: 'New-product default decline fee (USD/tx)',
    cfgDisputeFee: 'New-product default dispute fee (USD/tx)',
    cfgDepositFeeRate: 'Deposit fee rate (%)',
    cfgFXBaseRate: 'Platform exchange rate (USDT balance credited per 1 USDT; default 1, e.g. 0.9999)',
    cfgFXSpreadLimit: 'Maximum agent rate discount (%)',
    cfgFXOutOfBand: '{total} agent rates are outside the new band and now fall back to the platform rate. Ask agents to update them.',
    cfgUpCostRate: 'Platform top-up cost rate (%)',
    cfgWithdrawFeeRate: 'Withdrawal fee rate (%)',
    cfgCardWithdrawFee: 'Card transfer-out fee (USDT/tx)',
    cfgWarnLoss: 'After the user-referral top-up reward cap the deposit fee is {effective_rate}%, below the platform top-up cost of {upstream_cost_rate}%',
    cfgWarnMaxLevel: 'The deepest existing level is {deepest}; existing agents are unaffected, only new sub-agents beyond the limit are blocked',
    cfgCloseFee: 'New-product default close fee (USD/card)',
    cfgKycLimitVerified: 'Verified top-up cap (USD)',
    cfgDepositReview: 'Deposit review threshold (USDT)',
    cfgReserveAlert: 'Reserve alert threshold (USD)',
    cfgTimezone: 'Platform timezone (IANA)',
    cfgSupportTg: 'Support Telegram',
    cfgSupportEmail: 'Support email',
    cfgSupportHours: 'Support hours',
    cfgAlertChatId: 'Alert Telegram chat ID',
    cfgAlertEmail: 'Alert email',
    cfgAlertTest: 'Send test alert',
    cfgAlertTestHint: 'Sends one test message to the saved group ID and email. Not added to the alert list; at most once every 30 seconds.',
    cfgAlertTestSaveFirst: 'You have unsaved changes. Save the settings before sending a test alert.',
    cfgAlertTestTg: 'Telegram group',
    cfgAlertTestEmail: 'Alert email',
    cfgAlertTestOk: 'Sent',
    cfgAlertTestFail: 'Failed ({err})',
    cfgAlertTestUnknown: 'unknown reason',
    cfgAlertTestOkShort: 'OK',
    cfgAlertTestFailShort: 'failed',
    cfgAlertTestDone: 'Test alert done: Telegram {tg}, email {email}',
    cfgPaySla: 'Withdrawal pay SLA (hours)',
    errCfgField: 'Invalid value: {field}',
    unitLevel: 'levels',
    cfgFeeHint: "Platform top-up cost rate (%): used for the loss warning when saving the deposit fee rate, and also by the profit ledger to accrue the upstream top-up cost per deposit (each deposit × this rate, using the rate in effect at the deposit time).",
    cfgSharedHint: "This switch only offers the network to users. Orders also need at least one deposit address that is Effective + Allocating with healthy monitoring; otherwise users see 'channel under maintenance'.",
    cfgUsNothing: 'Nothing to save — no changes',
    cfgUsSaved: 'Saved and verified {n}: {labels}',
    cfgUsMismatch: 'Read-back mismatch: {labels}. Refresh and check',
    cfgUsReadbackFail: 'Submitted, but the read-back check failed ({err}). Refresh and check',
    cfgUsMore: ' and {n} more',
    cfgUsSwitchUnsaved: '{state} (unsaved)',
    cfgUsDirtyBar: '{n} unsaved changes: {labels}. Toggles and values take effect only after you click Save all.',
    cfgUsLeaveTitle: 'Discard unsaved changes?',
    cfgUsLeaveText: 'You have {n} unsaved changes ({labels}). Leave and discard them?',
    cfgUsLeaveStay: 'Stay',
    cfgUsLeaveGo: 'Discard and leave',
    gSecurity: 'Security',
    cfgSecurityHint: 'New values apply to newly issued sessions / at the next check. Mini App sessions stay fixed at 12 hours.',
    cfgAdminIdle: 'Console idle sign-out (minutes)',
    cfgAdminMaxHours: 'Console max session length (hours)',
    cfgAgentIdle: 'Agent portal idle sign-out (minutes)',
    cfgAgentMaxHours: 'Agent portal max session length (hours)',
    cfgUserRefreshDays: 'User app stay signed in (days)',
    gCard: 'Cards',
    cfgCardSpentCooling: 'Card spend cool-down (minutes after a transaction before re-checking spend with the upstream; shorter is more timely, too short may undercount spend)',
    cfgBudgetCardLow: 'Budget remaining card slots alert threshold',
    cfgBudgetCardLowHint: 'Budget remaining card slots alert threshold: a "low card slots" alert is sent when the upstream remaining card count of a system budget is at or below this value. At 0, card products are hidden automatically and users cannot open cards, so a critical alert is always sent. 0 = turn off the low card slots alert only. When alerted, raise the card limit in the upstream dashboard, then click Sync budgets on the Budgets page.',
    // 0041 ops health checks
    gHealth: 'Ops health',
    cfgOpsHint: 'The background worker checks host disk / memory / load, site availability and certificates, the database, the Finance host heartbeat and backups each round. Breaches are sent to the alert chat / email under Alerts & compliance. Recovery does not close an alert automatically; acknowledge it in the alert list.',
    cfgOpsEnabled: 'Ops health checks',
    cfgOpsInterval: 'Check interval (seconds, 30–3600)',
    cfgOpsDiskWarn: 'Disk usage warning (≥ %)',
    cfgOpsDiskCrit: 'Disk usage critical (≥ %)',
    cfgOpsMemWarn: 'Available memory warning (< %)',
    cfgOpsMemCrit: 'Available memory critical (< %)',
    cfgOpsLoadWarn: '5-min load per core warning (≥)',
    cfgOpsLoadCrit: '5-min load per core critical (≥)',
    cfgOpsSiteUrls: 'Sites to check (https, comma-separated, up to 10)',
    cfgOpsSiteFail: 'Consecutive failed rounds (critical)',
    cfgOpsSiteP95: 'Site P95 latency warning (last 20)',
    cfgOpsTlsWarn: 'Certificate days left warning (≤ days)',
    cfgOpsTlsCrit: 'Certificate days left critical (≤ days)',
    cfgOpsDbPing: 'Database round-trip warning (≥)',
    cfgOpsDbConn: 'Database connection usage warning (≥ %)',
    cfgOpsTreasuryStale: 'Finance host heartbeat timeout (minutes, critical)',
    cfgOpsBackupAge: 'Backup max age (hours)',
  },
};

export const REWRITES_SETTINGS: readonly string[] = ['cfgHint', 'cfgOpenFee'];
